"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ThemedErrorMessage_1 = require("./ThemedErrorMessage");
var errorHandler_1 = require("../../../service/errorHandler");
function errorMessageHoc(Component) {
    return function (props) {
        var _a = react_1.useState(null), error = _a[0], setError = _a[1];
        var componentHandleError = react_1.useCallback(function (err) {
            // Consider error that is false as a sign of handled error for easier handler chaining.
            if (error !== false) {
                error !== null && errorHandler_1.default.handleError(err);
                setError(err);
            }
        }, []);
        if (error) {
            return <ThemedErrorMessage_1.default fullPage={true} error={error} message={'exception.unhandledError.message'}/>;
        }
        return (<Component {...props} componentHandleError={componentHandleError}>
        {props.children}
      </Component>);
    };
}
exports.default = errorMessageHoc;
